import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerIndexComponent } from './crud-index/crud-index.component';
import { CustomerCESComponent } from './crud-ces/crud-ces.component';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

const routes: Routes = [
  {
    path: '',
    component: CustomerIndexComponent,
  },
  {
    path: 'new',
    component: CustomerCESComponent,
    data: { type: TypeCesEnum.NEW },
  },
  {
    path: 'show/:id',
    component: CustomerCESComponent,
    data: { type: TypeCesEnum.SHOW },
  },
  {
    path: 'edit/:id',
    component: CustomerCESComponent,
    data: { type: TypeCesEnum.EDIT },

  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomersRoutingModule { }
